import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import { errorToastMessage, successToastMessage } from "utils/errorToast";
import {
  HISTORY_TABLE_DATA,
  LOADER_STATUS,
  SELECT_UNIQUE,
  SELECTED,
  TOTAL_PAGES_HISTORY,
  TOTAL_PAGES_VIEW,
  VIEW_TABLE_DATA,
} from "./constants.js";
import {
  areMonthsInTwoFinancialYears,
  extractMonthsInRangeMMYYYY,
} from "../Utility/utility.js";
import moment from "moment";
import { data } from './../../Analytics/TurnOverAnalysis/RateWiseChart R&D';

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setViewTableData(viewTableData) {
  return {
    type: VIEW_TABLE_DATA,
    viewTableData: viewTableData,
  };
}

export function setHistoryTableData(historyTableData) {
  return {
    type: HISTORY_TABLE_DATA,
    historyTableData: historyTableData,
  };
}

export function setTotalPagesView(totalPagesView) {
  return {
    type: TOTAL_PAGES_VIEW,
    totalPagesView: totalPagesView,
  };
}

export function setTotalPagesHistory(totalPagesHistory) {
  return {
    type: TOTAL_PAGES_HISTORY,
    totalPagesHistory: totalPagesHistory,
  };
}

export function setSelected(selected) {
  return {
    type: SELECTED,
    selected: selected,
  };
}

export function setSelectedUnique(selectUnique) {
  return {
    type: SELECT_UNIQUE,
    selectUnique: selectUnique,
  };
}

export function getViewData(
  selectedGstin,
  return_period,
  search,
  isChecked,
  isToast = true,
  pageNo = 1,
  pageLimit = 10,
  return_period_filter,
  dateRange,
  gstinTaxpayerFilter,
  ctinTaxpayerFilter,
  inumFilter,
  docTypeFilter,
  invoiceTypeFilter,
  docStatusFilter,
  recoStatusFilter,
  dataTypeFilter
) {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstin,
      ret_period: return_period,
      str: search || "",
      gstrType: isChecked === true ? "2A" : "2B",
      pageNo,
      limit: pageLimit,
      ret_period_filter: return_period_filter,
      invoiceDate: dateRange,
      gstinTaxpayerFilter: gstinTaxpayerFilter,
      ctinArr: ctinTaxpayerFilter,
      inumArr: inumFilter,
      dtyArr: docTypeFilter,
      invoiceType: invoiceTypeFilter,
      dstArr: docStatusFilter,
      recStatusArr: recoStatusFilter,
      dataTypeArr: dataTypeFilter,
    };

    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getgstr2asalesData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === "0") {
        if (isToast) successToastMessage(response.data.message);
        dispatch(setViewTableData(response.data.data));
        let pages =
          response.data.data && response.data.data.length
            ? response.data?.data?.[0]?.TOTAL_RECORDS
            : 10;
        dispatch(setTotalPagesView(Math.ceil(pages / pageLimit)));
        return response.data.data;
      } else {
        if (isToast) errorToastMessage(response.data.message);
        dispatch(setViewTableData([]));
        return [];
      }
    } catch (error) {
      console.log(error);
      errorToastMessage(error || "Error in fetching view data");
    } finally {
      dispatch(loader(false));
    }
  };
}
export function get2a2bChangedData(
  selectedGstin,
  return_period,
  search,
  gstrType,
  isToast = true
) {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstin,
      ret_period: return_period,
      search: search || "",
      gstrType: gstrType === true ? "2A" : "2B",
    };
    console.log("get2a2bChangedData gstrType::", data.gstrType);
    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/getgstr2asalesData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === "0") {
        if (isToast) successToastMessage(response.data.message);
        dispatch(setViewTableData(response.data.data));
        return response.data.data;
      } else {
        if (isToast) errorToastMessage(response.data.message);
        dispatch(setViewTableData([]));
        return [];
      }
    } catch (error) {
      console.log(error);
      errorToastMessage(error || "Error in fetching view data");
    } finally {
      dispatch(loader(false));
    }
  };
}
export function getHistoryData(
  pageNo = 1,
  selectedGstin,
  return_period,
  search,
  return_period_fiter,
  selectedYear,
  gstinTaxpayerFilter,
  fetchStatusFilter,
  reportTypeFilter,
  isToast = true,
  limit = 15
) {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstin,
      ret_period: return_period,
      search: search ? search.trim() : "",
      ret_period_filter: return_period_fiter,
      financial_year: selectedYear,
      gstin_filter: gstinTaxpayerFilter,
      status: fetchStatusFilter,
      reportTypeFilter,
      pageNo,
      limit,
    };
    // console.log("DATA::", data);
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/fetchgstr2a2bdatahistory`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        if (isToast) successToastMessage(response.data.message);
        let pages = 10;
        if (response?.data?.data?.length) {
          pages = response.data.data[0].TOTAL_RECORDS
            ? response.data.data[0].TOTAL_RECORDS
            : response.data.data?.length;
        }
        // Add unique key using GSTIN and index
        const dataWithKeys = response.data.data.map((item, index) => ({
          ...item,
          uniqueKey: `${item?.GSTIN || "NA"}_${item?.FISCAL_YEAR || "NA"}_${
            item?.RET_PERIOD || "NA"
          }_${index}`,
        }));
        dispatch(setHistoryTableData(dataWithKeys));
        dispatch(setTotalPagesHistory(Math.ceil(pages / 15)));
        return dataWithKeys;
        // dispatch(setHistoryTableData(response.data.data));
        // dispatch(setTotalPagesHistory(Math.ceil(pages / 10)));
        // return response.data.data;
      } else {
        if (isToast) errorToastMessage(response.data.message);
        dispatch(setHistoryTableData([]));
        return [];
      }
    } catch (error) {
      console.error(error);
      errorToastMessage(`Error in getHistoryTablesData: ${error}`);
    } finally {
      dispatch(loader(false));
    }
  };
}

export const downloadFetchExcel =
  (selected, downloadType) => async (dispatch) => {
    dispatch(loader(true));
    console.log('SELECTED::', selected);
    // const gstin = selected?.flatMap((row) => row?.GSTIN);
    // const ret_period = selected?.flatMap((row) => row?.RET_PERIOD);
    // const report_type = selected?.flatMap((row) => row?.FETCH_TYPE);
    // const data = {
    //   gstin: [...new Set(gstin)],
    //   ret_period: [...new Set(ret_period)],
    //   report_type: [...new Set(report_type)],
    //   isConsolidated:
    //     downloadType === "consolidated"
    //       ? true
    //       : downloadType === "gstinWise"
    //       ? false
    //       : null,
    // };
const simplified = selected?.map(({ GSTIN, RET_PERIOD, FETCH_TYPE }) => ({
  gstin: GSTIN,
  ret_period: RET_PERIOD,
  type: FETCH_TYPE === "GSTR-2A" ? "gstr_2a" :  FETCH_TYPE === "GSTR-2B" ? "gstr_2b" : '',
}));
const data= {
  gstinData: simplified,
  isConsolidated:
         downloadType === "consolidated"
           ? true
           : downloadType === "gstinWise"
           ? false
           : null,
}
    console.log("download payload::", data);
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/download2a2bSalesData`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_Fetch.zip");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Data downloaded successfully");
    } catch (error) {
      errorToastMessage("Failed to download template");
    } finally {
      dispatch(loader(false));
    }
  };

export function fetchGSTR2A2B(selectedGstin, return_period, flag) {
  return async (dispatch) => {
    const data = { gstin: selectedGstin, ret_period: return_period };
    const url = `${Config.url}gstR2a2bnew/${
      flag === "gstr2a" ? "fetchgstr2a" : "fetchgstr2b"
    }`;
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage(response.data.message);
        return response.data.data;
      } else {
        errorToastMessage(response.data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
      errorToastMessage(error || "Error in Fetching 2a2b");
    } finally {
      dispatch(loader(false));
    }
  };
}

export const downloadViewExcel =
  (
    selectedGstin,
    return_period,
    searchView,
    isChecked,
    return_period_filter,
    dateRange,
    gstinTaxpayerFilter,
    ctinTaxpayerFilter,
    inumFilter,
    docTypeFilter,
    invoiceTypeFilter,
    docStatusFilter,
    recoStatusFilter,
    dataTypeFilter
  ) =>
  async (dispatch) => {
    dispatch(loader(true));

    const data = {
      gstinTaxpayerFilter: gstinTaxpayerFilter,
      gstin: selectedGstin,
      ret_period: return_period,
      ret_period_filter: return_period_filter,
      limit: 500000,
      str: searchView,
      ctinArr: ctinTaxpayerFilter,
      dtyArr: docTypeFilter,
      inumArr: inumFilter,
      dstArr: docStatusFilter,
      recStatusArr: recoStatusFilter,
      invoiceType: invoiceTypeFilter,
      invoiceDate: dateRange,
      dataType: dataTypeFilter,
      gstrType: isChecked === true ? "2A" : "2B",
    };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/download2a2bfetchviewData`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_View.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Data downloaded successfully");
    } catch (error) {
      errorToastMessage("Failed to download template");
      console.log("Error in downloadViewExcel: ", error);
    } finally {
      dispatch(loader(false));
    }
  };

export const getHistoryFilterList =
  (selectedGstin, return_period) => async (dispatch) => {
    dispatch(loader(true));
    const data = { gstin: selectedGstin, ret_period: return_period };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/fetchDataFetchHistoryFilterList`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === 0) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };

export const getViewFilterList =
  (selectedGstin, return_period, isChecked) => async (dispatch) => {
    dispatch(loader(true));
    const data = {
      gstin: selectedGstin,
      ret_period: return_period,
      gstrType: isChecked === true ? "2A" : "2B",
    };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/fetchsales2aViewFilterList`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error === 0) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };

export const downloadHistoryExcel =
  (
    selectedGstin,
    return_period,
    gstinTaxpayerFilter,
    return_period_filter,
    searchHistory,
    fetchStatusFilter,
    reportTypeFilter,
    selectedYear
  ) =>
  async (dispatch) => {
    dispatch(loader(true));

    const data = {
      gstin: selectedGstin,
      gstin_filter: gstinTaxpayerFilter,
      ret_period: return_period,
      ret_period_filter: return_period_filter,
      limit: 500000,
      search: searchHistory,
      reportTypeFilter: reportTypeFilter,
      financial_year: selectedYear,
      status: fetchStatusFilter,
    };

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR2a2bnew/download2a2bfetchhistory`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GSTR2a2b_History.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Excel downloaded successfully");
    } catch (error) {
      errorToastMessage("Failed to download excel");
    } finally {
      dispatch(loader(false));
    }
  };
